<section
  class="calendarReminders"
  [class.calendarReminders--first]="isStart"
  (click)="createReminder()"
  >
  @for (reminder of reminders; track reminder; let index = $index) {
    @if (index < 2) {
      <pp-reminder-calendar-element
        [ppReminder]="reminder"
      ></pp-reminder-calendar-element>
    }
    @if (index === 1 && reminders.length > 2) {
      <button
        class="calendarEvent__more"
        (click)="openDay(ppSegment.date, $event)"
        >
        <span>+{{ 'x_more' | ppTranslate: { count: reminders.length - 2 } }} </span>
      </button>
    }
  }
</section>
